import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import {
  InputHLPure,
  ArrowBtnHLPure,
  ButtonHLPure,
  DropDownBtnHLPure,
  TextAreaHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from "../../pures";
import { useTranslation } from "react-i18next";
import "./business-administration-detail.css";
import { businessIconDefault } from "../../../assets/logos/icons";


/**
 *
 * @param {*} {
 *   selectedUser,
 *   hideShowDetails,
 *   setStateNameComponentUser,
 *   validators,
 *   setHeaderTitleinDetail,
 *   optionsTypeBusiness,
 *   optionsBusinessTurnover,
 *   updateCompany,
 *   createCompany,
 *   token,
 *   nameComponentUser,
 *   changeImgFile,
 *   imgProfileSubtitle,
 *   handleChangeImgProfile,
 *   uploadFileCustom,
 *   setShowDetails,
 *   showWarningRequesting,
 *   showLoadingRequesting,
 *   showCompletedRequesting,
 *   showErrorRequesting,
 *   toggleCompletedRequesting,
 *   toggleLoadingRequesting,
 *   toggleErrorRequesting,
 *   toggleWarningRequesting,
 *   toggleCompletedModel,
 *   resetImageProfile,
 *   message,
 *   imageProfile,
 * }
 * @return {*} 
 * @status no delete
 * @description Layout for the business administration details page. Includes all information on the company
 */
const BusinessAdministrationDetailView = ({
  selectedUser,
  hideShowDetails,
  setStateNameComponentUser,
  validators,
  setHeaderTitleinDetail,
  optionsTypeBusiness,
  optionsBusinessTurnover,
  updateCompany,
  createCompany,
  token,
  nameComponentUser,
  changeImgFile,
  uploadFileCustom,
  setShowDetails,
  showWarningRequesting,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  toggleCompletedModel,
  resetImageProfile,
  message,
  imageProfile,
}) => {
  const redirectToComponets = (e) => {
    setStateNameComponentUser(e.currentTarget.dataset.id);
    setHeaderTitleinDetail({ clicked: true, name: e.currentTarget.dataset.id });
  };

  const [description, setDescription] = useState(
    nameComponentUser !== "Agregar nueva empresa"
      ? selectedUser.company.description
      : ""
  );
  const [companyName, setCompanyName] = useState(
    nameComponentUser !== "Agregar nueva empresa"
      ? selectedUser.companyName
      : ""
  );
  const [clientName, setClientName] = useState(
    nameComponentUser !== "Agregar nueva empresa" ? selectedUser.clientName : ""
  );
  const [rfc, setRFC] = useState(
    nameComponentUser !== "Agregar nueva empresa"
      ? selectedUser.company.rfc
      : ""
  );
  const [errorInRFC, setErrorInRFC] = useState(false);

  const [errorInBusinessName, setErrorInBusinessName] = useState(false);
  const [errorInNameSocial, setErrorInNameSocial] = useState(false);
  const [errorInDescription, setErrorInDescription] = useState(false);

  const [typeBusiness, setOptionsTypeBusiness] = useState(
    selectedUser.typeOfCompany || optionsTypeBusiness[0].typeOfCompany
  );
  const [businessTurnover, setOptionsBusinessTurnover] = useState(
    selectedUser.turnOfTheCompany || optionsBusinessTurnover[0].turnOfTheCompany
  );


  /* Handlers to change the input fields in the business administration view */

  /**
   * @status no delete
   * @param {*} e
   */
  const handleChangeDescription = (e) => {
    setDescription(e.target.value);
  };

  /**
   * @status no delete
   * @param {*} e
   */
  const handleChangeRFC = (e) => {
    setRFC(e.target.value);
  };


  /**
   * @status no delete
   * @param {*} e
   */
  const handleChangeCompanyName = (e) => {
    setCompanyName(e.target.value);
  };


  /**
   * @status no delete
   * @param {*} e
   */
  const handleChangeClientName = (e) => {
    setClientName(e.target.value);
  };


  /**
   * @status no delete
   * @param {*} e
   */
  const handleChangeOptionsTypeBusiness = (e) => {
    e.preventDefault();
    setOptionsTypeBusiness(e.target.value);
  };


  /**
   * @status no delete
   * @param {*} e
   */
  const handleChangeOptionsBusinesTurnover = (e) => {
    setOptionsBusinessTurnover(e.target.value);
  };

  const { t } = useTranslation();


  /**
   * @description handler to save the client company information
   * @status no delete
   */
  const handleSaveClientCompany = () => {
    let invalidateRFC = validators.rfcValidator(rfc);
    let invalidateBusinessName = validators.businessNameValidator(companyName);
    let invalidateNameSocial = validators.nameSocialValidator(clientName);
    let invalidateDescription = validators.businessDescriptionValidator(description);

    if (invalidateRFC !== "") {
      setErrorInRFC(true);
    } else {
      setErrorInRFC(false);
    }
    if (invalidateBusinessName !== "") {
      setErrorInBusinessName(true);
    } else {
      setErrorInBusinessName(false);
    }
    if (invalidateNameSocial !== "") {
      setErrorInNameSocial(true);
    } else {
      setErrorInNameSocial(false);
    }
    if (invalidateDescription !== "") {
      setErrorInDescription(true);
    } else {
      setErrorInDescription(false);
    }

    if (
      invalidateRFC === "" &&
      invalidateBusinessName === "" &&
      invalidateNameSocial === "" &&
      invalidateDescription === ""
    ) {
      const bodyCreate = {
        companyName: companyName,
        businessName: clientName,
        typeOfCompany: typeBusiness,
        rfc: rfc,
        turnOfTheCompany: businessTurnover,
        description: description === "" ? null : description,
      };
      const bodyUpdate = {
        companyId: selectedUser.companyId,
        companyName: companyName,
        businessName: clientName,
        typeOfCompany: typeBusiness,
        rfc: rfc,
        turnOfTheCompany: businessTurnover,
        description: description === "" ? null : description,
      };
      if (nameComponentUser === "Agregar nueva empresa") {
        createCompany(token, bodyCreate);
      } else {
        updateCompany(token, bodyUpdate);
      }
    }
  };

  useEffect(() => {
    if (resetImageProfile) {
      resetImageProfile();
    }
  }, [])

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationAddNewUserView-wrapper"
    >
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="businessAdministrationAddressView-header"
        >
          <SubtitlePageHLPure
            subtitle={
              nameComponentUser === "Agregar nueva empresa"
                ? t("businessAdministrationPanelView.addCompany")
                : t("businessAdministrationPanelView.seeDetail")
            }
            imgProfile={businessIconDefault}
            profileImg={
              nameComponentUser === "Ver detalle/Editar"
                ? selectedUser?.imgProfile
                : imageProfile
            }
            tooltipShow
            openTooltipDescription={true}
            positionTooltip={"left"}
            titleTooltip={"Personaliza el logo"}
            descriptionTooltip={"Da clic para agregar una imagen que identifique a tu empresa."}
            informationIcon={false}
            altCustomImg={"Empresa"}
            // handleChangeImage={handleChangeImgProfile}
            uploadFile={(e) => uploadFileCustom(e)}
            changeImgFile={changeImgFile}
            justShowImg={false}
          />
        </Grid>
        <Grid
          item
          className="businessAdministrationAddressView-body"
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
        >
          {/*Container primera seccion de items, fila*/}
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="businessAdministrationAddressView-form"
          >
            {/*Container first second items, col 1*/}

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="businessAdministrationAddressView-inputs"
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                es={3}
                className="businessAdministrationAddressView-col1"
              >
                <Grid
                  item
                  className="businessAdministrationAddressView-buttonHLPure"
                >
                  <InputHLPure
                    labelInput={`${t("businessAdministrationDetailView.businessName")}`}
                    valueInput={companyName}
                    typeInput={"text"}
                    required
                    handleChangeInput={(e) => handleChangeCompanyName(e)}
                    inputActive
                    errorInput={errorInBusinessName}
                    errorInputText={t(
                      "businessAdministrationDetailView.errorBusinessName"
                    )}
                    tooltipShow
                    informationIcon
                    positionTooltip={"top"}
                    titleTooltip={"Nombre comercial"}
                    descriptionTooltip={`${t("businessAdministrationDetailView.businessNameTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                  />
                </Grid>
                <Grid
                  item
                  className="businessAdministrationAddressView-inputHLPure"
                >
                  <InputHLPure
                    labelInput={"Razón Social"}
                    valueInput={clientName}
                    typeInput={"text"}
                    required
                    handleChangeInput={(e) => handleChangeClientName(e)}
                    inputActive
                    errorInput={errorInNameSocial}
                    errorInputText={t(
                      "businessAdministrationDetailView.errorNameSocial"
                    )}
                    tooltipShow
                    informationIcon
                    positionTooltip={"top"}
                    titleTooltip={"Razón Social"}
                    descriptionTooltip={`${t("businessAdministrationDetailView.nameSocialTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                  />
                </Grid>
                <Grid
                  item
                  className="businessAdministrationAddressView-inputHLPure"
                >
                  <DropDownBtnHLPure
                    labelDropDown={"Tipo de empresa"}
                    optionsDropDown={optionsTypeBusiness}
                    valueItem={"typeOfCompany"}
                    nameOption={"typeOfCompany"}
                    optionsValue={typeBusiness}
                    required
                    onDropDownChange={(e) => handleChangeOptionsTypeBusiness(e)}
                  />
                </Grid>
              </Grid>
              {/*Container second section items, col 2*/}
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="businessAdministrationAddressView-col2"
              >
                <Grid
                  item
                  className="businessAdministrationAddressView-inputHLPure"
                >
                  <InputHLPure
                    labelInput={"RFC"}
                    typeInput={"text"}
                    valueInput={rfc}
                    handleChangeInput={(e) => handleChangeRFC(e)}
                    inputActive
                    required
                    errorInput={errorInRFC}
                    errorInputText={t(
                      "businessAdministrationDetailView.errorRFC"
                    )}
                    tooltipShow
                    informationIcon
                    positionTooltip={"top"}
                    titleTooltip={"RFC"}
                    descriptionTooltip={t("businessAdministrationDetailView.RFCTooltip")}
                  />
                </Grid>
                <Grid
                  item
                  className="businessAdministrationAddressView-dropDownBtnHLPure"
                >
                  <DropDownBtnHLPure
                    labelDropDown={"Giro de la empresa"}
                    optionsDropDown={optionsBusinessTurnover}
                    valueItem={"turnOfTheCompany"}
                    nameOption={"turnOfTheCompany"}
                    optionsValue={businessTurnover}
                    required
                    onDropDownChange={(e) =>
                      handleChangeOptionsBusinesTurnover(e)
                    }
                  />
                </Grid>
                <Grid
                  item
                  className="businessAdministrationAddressView-dropDownBtnHLPure"
                >
                  <TextAreaHLPure
                    labelTextArea={"Descripción"}
                    typeInput={"text"}
                    handleChangeTextArea={(e) => handleChangeDescription(e)}
                    valueTextData={description}
                    errorInput={errorInDescription}
                    errorTextArea={t(
                      "businessAdministrationDetailView.errorDescription"
                    )}
                    tooltipShow
                    informationIcon
                    positionTooltip={"top"}
                    titleTooltip={"Descripción"}
                    descriptionTooltip={`${t("businessAdministrationDetailView.descriptionTooltip")} ${t("businessAdministrationDetailView.validCharactersDescription")}`}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <p className="businessAdministrationDetailView-required-label"><span>*</span> {t("businessAdministrationDetailView.requiredFields")}</p>
            </Grid>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="businessAdministrationDetailView-btnGroup"
          >
            <div className="businessAdministrationDetailView-spaceBtns">
              <ButtonHLPure
                primary={false}
                nameBtn={"Cancelar"}
                onClickBtn={hideShowDetails}
              />
            </div>
            {nameComponentUser !== "Agregar nueva empresa" ? (
              <>
                <div className="businessAdministrationDetailView-spaceBtns">
                  <ArrowBtnHLPure
                    textArrowBtn={"Domicilio empresa"}
                    onClickArrowBtn={() => {
                      setStateNameComponentUser("Domicilio empresa");
                      setShowDetails(true);
                    }}
                    dataSetProp={"Domicilio empresa"}
                    primary={false}
                  />
                </div>
                <div className="businessAdministrationDetailView-spaceBtns">
                  <ArrowBtnHLPure
                    textArrowBtn={"Inhabilitar empresa"}
                    onClickArrowBtn={() => {
                      setStateNameComponentUser("Inhabilitar empresa");
                      setShowDetails(true);
                    }}
                    dataSetProp={"Inhabilitar empresa"}
                  />
                </div>
              </>
            ) : (
              ""
            )}

            <ButtonHLPure
              primary
              nameBtn={"Guardar"}
              onClickBtn={handleSaveClientCompany}
            />
          </Grid>
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedModel}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            message={message}
          />
        </Grid>
      </>
    </Grid>
  );
};

export default BusinessAdministrationDetailView;
